export default __webpack_public_path__ + "static/statys-background-animation-large-989ae0a5bb058fc875c46180bb44ba12.svg";